module.exports = __webpack_public_path__ + "img/NewMotoIcon.01442b37.svg";